import type { OptionsDocument } from 'paintscout'
import { getEventTypes } from '../../options'

export function translateEventType({ eventType, options }: { eventType: string; options: OptionsDocument }): string {
  const eventTypes = getEventTypes({ options, includeDeleted: true })

  const found = eventTypes.find((et) => et.key === eventType)
  if (found) {
    return found.label
  }
  if (eventType === 'production') {
    return 'Job'
  }
  return eventType
}
